import React from 'react';

export const PlayIcon = ({ className }) => (
  <svg className={className} width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_2201_82475)">
      <circle cx="14.4961" cy="14" r="14" fill="#242424" />
      <circle cx="14.4961" cy="14" r="13.75" stroke="white" strokeOpacity="0.12" strokeWidth="0.5" />
    </g>
    <path
      d="M10.7461 9.73021C10.7461 8.95624 11.6091 8.48857 12.2657 8.90669L19.4425 13.4765C20.0473 13.8616 20.0473 14.7384 19.4425 15.1235L12.2657 19.6933C11.6091 20.1114 10.7461 19.6438 10.7461 18.8698V14.3V9.73021Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_b_2201_82475"
        x="-55.5039"
        y="-56"
        width="140"
        height="140"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="28" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2201_82475" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2201_82475" result="shape" />
      </filter>
    </defs>
  </svg>
);
